import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import axios from "axios";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";

function LoginPage({ logo }) {
  const customer = localStorage.getItem("rms-customer");
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`${apiKey}/api/rms/customer/login`, formData)
      .then((res) => {
        localStorage.setItem("rms-customer", JSON.stringify(res.data.data));
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate("/");
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    if (customer) {
      navigate("/");
    }
  }, [customer, navigate]);
  return (
    <>
      <div className="grid place-items-center max-w-7xl mx-auto w-[90%] min-h-[80vh] px-4 py-16">
        <div className="max-w-2xl w-full">
          <div>
            <img className="mx-auto w-56" src={logo} alt="" />
            <h1 className="text-xl font-medium text-w-heading text-center mt-4">
              Welcome Back
            </h1>
          </div>
          <form onSubmit={handleSubmit} className="w-full max-w-sm mx-auto">
            <div className="flex flex-col mt-5 lg:flex lg:flex-col mx-auto w-full">
              <input
                className="h-9 px-2 w-full"
                type="text"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="flex mt-5 w-full border rounded">
              <input
                className="h-9 px-2 w-full"
                type={!showPassword ? "password" : "text"}
                placeholder="Password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="px-2"
                onClick={() => setShowPassword(!showPassword)}
              >
                {!showPassword ? (
                  <FaEye className="text-[#584869]" />
                ) : (
                  <FaEyeSlash className="text-[#584869]" />
                )}
              </button>
            </div>
            <div className="w-full">
              <Link className="float-right text-xs text-[#7EBAFF] mt-1 hover:underline">
                Forgot Password?
              </Link>
            </div>
            <div className="w-full mt-8 flex">
              <button
                to={"submit"}
                className="bg-w-btn text-w-btn-text max-w-[12rem] w-full px-2 py-1 rounded mx-auto text-center"
              >
                Login
              </button>
            </div>
          </form>
          <div className="mt-24 w-full">
            <p className="text-center text-sm font-medium">
              Don't have an account?{" "}
              <Link to={"/signup"} className="text-w-bg hover:underline">
                Register
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
